/// <amd-module name="Analytics/Boards/VelocityQueries/CompletedLateMetastateByIterationDetailsQuery" />
import { ODataQueryOptions } from "Analytics/Common/ODataQueryOptions";
import { QueryUtilities } from "Analytics/Common/Utilities/QueryUtilities";
import { latestODataVersion } from "Analytics/Common/Utilities/QueryUtilities";
import { VelocityQueryBase } from "./VelocityQueryBase";

import { WorkItemWithState } from "Analytics/Boards/BoardsQueries/DataContracts";
import { Iteration } from "Analytics/Boards/BoardsQueries/IterationsQuery";
import { CompletedLateMetastateByIterationsQuery } from "./CompletedLateMetastateByIterationsQuery";

/**
 * Exposes a list of work items in particular iteration. Used for click-through.
 */
export class CompletedLateMetastateByIterationDetailsQuery extends VelocityQueryBase<WorkItemWithState[]> {
    private static generateQueryOptions(
        iteration: Iteration,
        projectId: string,
        teamId: string,
        workItemTypes: string[],
        showResolvedItemsAsCompleted = false,
        delay?: number
    ): ODataQueryOptions {
        const iterations = [iteration];
        const iterationAndCompletedDateClause = CompletedLateMetastateByIterationsQuery.generateIterationAndCompletedDateClause(iterations, delay);

        const workItemTypeClause = QueryUtilities.isInArray("WorkItemType", workItemTypes, true /* useQuotes */);

        let $apply =
            `filter(` +
            `Teams/any(t:t/TeamSK eq ${teamId})` +
            ` and (${workItemTypeClause})` +
            ` and (StateCategory eq 'Completed'`;
            

        if (showResolvedItemsAsCompleted) {
            $apply += 
                ` or StateCategory eq 'Resolved'` +
                ` or State eq 'Resolved'`;
        }

        $apply += `) and ${iterationAndCompletedDateClause})`;

        return {
            entityType: "WorkItems",
            oDataVersion: latestODataVersion,
            project: projectId,
            $apply: $apply,
            $select: "WorkItemId, StateCategory, State"
        };
    }
    private queryName?: string;

    constructor(
        command: string,
        iteration: Iteration,
        projectId: string,
        teamId: string,
        workItemTypes: string[],
        showResolvedItemsAsCompleted = false,
        delay?: number,
        queryName?: string
    ) {
        super(command, CompletedLateMetastateByIterationDetailsQuery.generateQueryOptions(iteration, projectId, teamId, workItemTypes, showResolvedItemsAsCompleted, delay));
        this.queryName = queryName;
    }

    public getQueryName(): string {
        return this.queryName || "CompletedLateMetastateByIterationDetailsQuery";
    }
}
